import React, { Component } from "react";
import * as _ from "lodash";
import translate from '../translations/translations.wrapper.jsx';
import * as reduxSelectors from '../store/application.reducers';
import {connect} from 'react-redux';

import {EditableDimension, EditableEmails} from './ProjectsEditables.component';

class ProjectsApprovers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            users: [],
            roles: null,
            newUsers: [],
            newRoles: [],
            selectedIdRole: this.props.idRole
        };
        this.changeIdRole = this.changeIdRole.bind(this);
        this.changeApproverEmail = this.changeApproverEmail.bind(this);
        this.mapUserEmails = this.mapUserEmails.bind(this);
        this.mapUserRole = this.mapUserRole.bind(this);
    }

    changeIdRole(idRole) {
        this.props.saveIdRole(idRole);
        this.setState({
            selectedIdRole: idRole.value
        });
    }

    changeApproverEmail(value) {
        this.setState({
            users: value
        });
        this.props.saveApproverEmail(value);
    }

    mapUserEmails() {
        return this.props.approvers.map((approver, index) => {
            return _.find(this.props.users, (user) => {
                return user.value === approver;
            });
        });
    }

    mapUserRole() {
        return _.find(this.props.roles, (role) => {
            return role.value === this.props.idRole
        });
    }

    render() {
        if (this.props.users && this.props.roles) {
            let userRole = this.mapUserRole();
            let users = this.mapUserEmails();

            let userEmails = users.length > 0 ? users.map((user, index) => {
                return <div className="margin-right align-self-center" key={index}>{user ? user.label : ''}</div>
            }) : <span/>;

            if (this.props.editMode) {
                return (
                    <>
                        <div className="col align-self-center">
                            <EditableDimension
                                value={userRole}
                                translate={this.props.translate}
                                changeValue={this.changeIdRole}
                                options={this.props.roles}/>
                        </div>
                        <div className="col align-self-center">
                            <EditableEmails changeValue={this.changeApproverEmail}
                                            value={users}
                                            translate={this.props.translate}
                            />
                        </div>
                    </>
                )
            }
            else {
                return (
                    <>
                        <div className="col align-self-center">{userRole ? userRole.label : ''}</div>
                        <div className="col align-self-center">{userEmails}</div>
                    </>
                )
            }
        }
        else {
            return (
                <>
                    <div className="col"></div>
                    <div className="col"></div>
                </>
            );
        }
    }
}

const withTranslations = translate(ProjectsApprovers);
const mapStateToProps = function (store) {
    return {
        roles: reduxSelectors.getProjectsRoles(store),
        users: reduxSelectors.getProjectsUsers(store),
    };
};

const connected = connect(mapStateToProps)(withTranslations);
export default connected;
